var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"error-template"},[_c('img',{staticClass:"lincLogo",attrs:{"alt":"Linc logo","src":require("../assets/v2/images/logo-linc.png")}}),_c('div',{staticClass:"error-details"},[_vm._v(" Customer Satisfaction Survey ")])])])])])
}]

export { render, staticRenderFns }